import './styles.css';

/**
 * Страница для поставщиков
 * @returns {JSX.Element}
 */
export const ForSuppliers: React.FC = () => {
    return (
        <div className="suppliers-container">
        <h1 className="suppliers-title">Поставщикам</h1>
        <div className="suppliers-content">
            <p>Приглашаем к сотрудничеству компании, имеющие свои склады с автотоварами и налаженную систему логистики, желающие увеличить продажи. Интересуют компании как в ДФО, так и за его пределами.</p>
            <p>Мы гордимся нашими многолетними партнерскими связями и предлагаем взаимовыгодное сотрудничество на долгосрочной основе. Если у Вас есть желание стать нашим партнером, просим связаться с нами любым удобным способом.</p>
            {/* <p> <p>Пишите нам на электронный адрес <a href="mailto:km.podzamenu@gmail.com" style={{color: "#ce5e02"}}>km.podzamenu@gmail.com</a> с темой “Сотрудничество” либо звоните/пишите на <a href="https://api.whatsapp.com/send?phone=79147169282" style="color: #ce5e02;" target="_blank">WhatsApp +79147169282</a></p> */}
        </div>
    </div>
    );
};